import { Button } from "react-bootstrap";

export const transactionTypeList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Pinjaman",
    count: 0,
    value: "disburse-loan",
    active: false,
  },
  {
    text: "Pembayaran",
    count: 0,
    value: "payment-loan",
    active: false,
  },
  {
    text: "Perpanjangan",
    count: 0,
    value: "extension",
    active: false,
  },
  {
    text: "Lelang Barang",
    count: 0,
    value: "auction",
    active: false,
  },
  {
    text: "Pengembalian Dana",
    count: 0,
    value: "refund",
    active: false,
  },
];

export const initFilterInput = {
  searchName: "",
  category: 0,
  paymentType: "semua",
  tenorType: "semua",
  paymentMethod: "semua",
  tenor: 0,
  outlets: [],
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  transactionType: "semua",
  sortingField: null,
  sortingOrder: null,
};

export const renderColumns = (handleDetailButtonClick = null) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "7%",
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "customer_name",
      title: "Nama Nasabah",
      sorter: true,
      width: "13%",
    },
    {
      dataIndex: "transactionType",
      key: "transactionType",
      title: "Jenis Transaksi",
    },
    // {
    //   dataIndex: "paymentType",
    //   key: "paymentType",
    //   title: "Jenis Pembayaran",
    // },
    {
      dataIndex: "tenorType",
      key: "tenorType",
      title: "Jenis Tenor",
    },
    {
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      title: "Metode Pembayaran",
    },
    {
      dataIndex: "tenor",
      key: "tenor",
      title: "Tenor",
      width: "8%",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah",
      width: "11%",
    },
    {
      dataIndex: "transactionProof",
      key: "transactionProof",
      title: "Bukti Transaksi",
    },
    {
      dataIndex: "voucher",
      key: "voucher",
      title: "Voucher",
    },
    ...(handleDetailButtonClick
      ? [
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            render: (_, record) => (
              <div style={{ textAlign: "center", display: "grid" }}>
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => handleDetailButtonClick(record.transactionID)}
                >
                  Detail
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
};
